<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="执行考核" size="50%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-row>
            <el-col>
              <el-form-item label="申诉内容" >
                <el-input type="textarea" v-model="formData.siteAnswerNote" :readonly="true"
                          :autosize="{ minRows: 4, maxRows: 8}" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="6">
              <el-form-item label="考核金额">
                <el-input v-model="formData.standardAmount" :readonly="true"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="调整金额">
                <el-input-number v-model="formData.adjustAmount" :precision="2" :step="1" :min="-9999" :max="9999"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额">
                <el-input v-model="formData.amount" :readonly="true"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="最后审批金额">
                <el-input v-model="formData.checkAmount" :readonly="true"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="6">
              <el-form-item label="凭证1" style="width: 30%;">
                <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove1"
                           list-type="picture-card"
                           :file-list="picList1"
                           :on-success="(res,file, fileList) => {handleSuccess1(res,file, fileList)}"
                           :on-change="(files, fileList) => {handleImageChange(fileList)}"
                           :auto-upload="true" :headers="headers">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item style="width: 30%;" label="凭证2">
                <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove2"
                           list-type="picture-card"
                           :file-list="picList2"
                           :on-success="(res,file, fileList) => {handleSuccess2(res,file, fileList)}"
                           :on-change="(files, fileList) => {handleImageChange(fileList)}"
                           :auto-upload="true" :headers="headers">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item style="width: 30%;" label="凭证3">
                <el-upload style="display:flex" :action="api.uploadFileUrl" :on-remove="handleRemove2"
                           list-type="picture-card"
                           :file-list="picList3"
                           :on-success="(res,file, fileList) => {handleSuccess3(res,file, fileList)}"
                           :on-change="(files, fileList) => {handleImageChange(fileList)}"
                           :auto-upload="true" :headers="headers">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item label="审批意见" :label-width="formLabelWidth">
                <el-input type="textarea"
                          :autosize="{ minRows: 4, maxRows: 8}" v-model="formData.checkNote" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute; bottom: 5px; right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="auditBill">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'dataId'],
  created() {
    this.formData.id = this.dataId
  },
  mounted() {
    this.getData()
  },
  computed: {
    api() {
      return api
    },

    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  watch: {
    'formData.adjustAmount': {
      handler(n) {
        if (!isNaN(n)) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
        }
      },
      deep: true
    }
  },
  data() {
    return {
      picList1: [],
      picList2: [],
      picList3: [],
      formData: {
        remark: null,
        id: null
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {
    // 执行考核
    auditBill() {
      this.formData.proofAttachment1 = uploadFileFormat(this.picList1)
      this.formData.proofAttachment2 = uploadFileFormat(this.picList2)
      this.formData.proofAttachment3 = uploadFileFormat(this.picList3)
      if (isNaN(this.formData.adjustAmount)) {
        this.formData.adjustAmount = 0
      }
      this.$http({
        url: api.sfCheckBill.auditDataUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('执行考核成功')
        this.$emit('closeD')
        this.$emit('flushed')
        // this.reload()
      })
    },

    getData() {
      this.$http({
        url: api.sfCheckBill.getDataUrl,
        method: 'post',
        data: {id: this.formData.id}
      }).then(res => {
        let data = res.data.data
        this.formData = data
        this.picList1 = echoFileFormat(data.proofAttachment1)
        this.picList2 = echoFileFormat(data.proofAttachment2)
        this.picList3 = echoFileFormat(data.proofAttachment3)
      })
    },

    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = echoFileFormat(res.data.url)
    },

    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = [
        {url: res.data.url}
      ]
    },

    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = [
        {url: res.data.url}
      ]
    },

    handleRemove1() {
      this.picList1 = []
    },
    handleRemove2() {
      this.picList2 = []
    },
    handleRemove3() {
      this.picList3 = []
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },


    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}

// 装图片的  大框
::v-deep .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.pics {
  display: flex;
  margin-top: 10px;
}
::v-deep .el-input-number [role=button] {
    line-height: 26px;
    height: 26px;
    margin-top: 40px;
}
.el-input-number--medium {
    width: 200px;
    display: block;
    line-height: 34px;
}
</style>
